/**
 * @fileoverview POST handler for the "/engagement/report_dashboard/:dashboard_id/create_tile_from_report_builder_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardIdCreateTileFromReportBuilderReportCacheKeys } from "./constants";
import type {
  PostEngagementReportDashboardDashboardIdCreateTileFromReportBuilderReportProps,
  EngagementReportDashboardDashboardIdCreateTileFromReportBuilderReportResult,
} from "./types";

export const postEngagementReportDashboardDashboardIdCreateTileFromReportBuilderReport = reactQueryMutationAdapter(
  engagementReportDashboardDashboardIdCreateTileFromReportBuilderReportCacheKeys,
  (
    props: PostEngagementReportDashboardDashboardIdCreateTileFromReportBuilderReportProps
  ): Promise<EngagementReportDashboardDashboardIdCreateTileFromReportBuilderReportResult> => {
    return fetch(
      `/engagement/report_dashboard/${props.dashboardId}/${props.appGroupId}/create_tile_from_report_builder_report`,
      "POST",
      {
        report_id: props.reportId,
      }
    );
  }
);
